module.exports = __webpack_public_path__ + "img/event_alert.b4de41db.png";